export default "__VITE_ASSET__tMowqWYM__"